import {
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
  schPositiveInt,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateBelowGradeFullBathCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (isUndefined(improvementsForTransaction) || isUndefined(identification)) {
    return undefined;
  }

  const {
    basement,
    craftsmanQuality: quality,
    propertyType = 'singleFamilyResidence',
  } = improvementsForTransaction;
  const {
    address: { PostalCode: zipCode },
  } = identification;

  const fullBaths = basement?.fullBaths ?? schPositiveInt.parse(0);

  if (
    isUndefined(quality) ||
    (quality * 10) % 1 !== 0 ||
    quality < 1 ||
    isUndefined(zipCode) ||
    !ORDER_FEATURES.basement.hasFeature(improvementsForTransaction)
  ) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  return calculator.getFullBathroomsCost({
    fullBaths,
    quality,
    propertyType,
    zipCode,
  });
};

export const {
  selectBelowGradeFullBathCost,
  selectZipOnlyBelowGradeFullBathCost,
  selectBelowGradeFullBathCosts,
} = createFeatureCostSelectors({
  calculate: calculateBelowGradeFullBathCost,
  inputSelectors: [
    selectCostProps,
    selectImprovementsEntities,
    selectPropertyIdentificationEntities,
  ],
  names: {
    cost: 'selectBelowGradeFullBathCost',
    zipOnly: 'selectZipOnlyBelowGradeFullBathCost',
    costs: 'selectBelowGradeFullBathCosts',
  },
});
